import React from "react";
import { jsPDF } from "jspdf";

const TemplatePreviewModal = ({ template, onClose }) => {
  const handleDownloadPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("Template Preview", 10, 10);

    doc.setFontSize(12);
    doc.text(`ID: ${template.id}`, 10, 20);
    doc.text(`Title: ${template.title}`, 10, 30);
    doc.text(`Author: ${template.author}`, 10, 40);
    doc.text(`Email: ${template.email}`, 10, 50);
    doc.text(`Product Type: Signage`, 10, 60);
    doc.text(`Question Type: MCQ`, 10, 70);
    doc.text("Sample Questions:", 10, 85);
    doc.text("1. What is the size of signage?", 10, 95);
    doc.text("2. What material to use?", 10, 105);

    doc.save(`${template.title}.pdf`);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
      <div className="bg-white rounded-xl p-6 w-[500px] shadow-lg relative">
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute right-4 top-2 text-2xl font-bold"
        >
          ✕
        </button>

        <h2 className="text-lg font-semibold mb-4">Template Preview</h2>

        <div className="border p-4 rounded-lg bg-gray-50 mb-4">
          <p>
            <b>ID:</b> {template.id}
          </p>
          <p>
            <b>Title:</b> {template.title}
          </p>
          <p>
            <b>Author:</b> {template.author}
          </p>
          <p>
            <b>Email:</b> {template.email}
          </p>
          <p>
            <b>Product Type:</b> Signage
          </p>
          <p>
            <b>Question Type:</b> MCQ
          </p>

          <div className="mt-3">
            <b>Questions:</b>
            <ul className="list-disc ml-4 text-sm">
              <li>What is the size of signage?</li>
              <li>What material to use?</li>
              <li>Do you need illumination?</li>
            </ul>
          </div>
        </div>

        <button
          onClick={handleDownloadPDF}
          className="w-full py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
        >
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default TemplatePreviewModal;
